export default "__VITE_ASSET__C4C0CM8___"